import { render, staticRenderFns } from "./ReturnAndRefund.vue?vue&type=template&id=4fb0aad3&"
import script from "./ReturnAndRefund.vue?vue&type=script&lang=js&"
export * from "./ReturnAndRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports